
import React, { useState } from "react";
import api from "./api";

const ForgotPassword = ({ onBack }) => {
    const [clientNumber, setClientNumber] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");
        setError("");
        setLoading(true);

        try {
            const res = await api.post("/request-password-reset.php", {
                nr_user: clientNumber.trim()
            });

            setMessage(
                res.data.message ||
                "Jeśli konto z tym adresem istnieje, wyślemy link do zmiany hasła."
            );
        } catch (err) {
            setError(
                err.response?.data?.error ||
                "Nie udało się wysłać prośby. Spróbuj ponownie później."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-box">
                <h2>ROD ZGODA Bytom</h2>
                <h2>Resetowanie hasła</h2>
                <p className="subtitle">
                    Podaj identyfikator przypisany do konta.
                </p>

                <form onSubmit={handleSubmit}>
                
                <input
                    type="text"
                    placeholder="Identyfikator klienta"
                    value={clientNumber}
                    onChange={(e) => setClientNumber(e.target.value)}
                    required
                />

                <button type="submit" disabled={loading}>
                    {loading ? "Wysyłanie..." : "Wyślij link"}
                </button>

                </form>

                {message && (
                    <p className="message" role="status">{message}</p>
                )}

                {error && (
                    <p className="message" role="alert">{error}</p>
                )}

                <button type="button" onClick={onBack}>
                    Wróć do logowania
                </button>
            </div>
        </div>
    );
};

export default ForgotPassword;
